// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/create-shop-article-tax-history-request-schema',
  type: 'object',
  required: ['id', 'shopArticleTaxId', 'taxRate', 'validFrom'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    shopArticleTaxId: {
      type: 'integer',
    },
    taxRate: {
      type: 'number',
    },
    validFrom: {
      type: 'string',
      format: 'date-time',
    },
    validTo: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
